import { NgModule, ModuleWithProviders } from '@angular/core';
import {
  SocialLoginModule,
  GoogleLoginProvider,
  FacebookLoginProvider,
  AuthServiceConfig,
  AuthService,
} from 'angularx-social-login';

import {
  SessionService,
  UserService,
  ProfileService,
  RecoveryService,
  USER_CONFIG,
} from '@relevance/angular-core';

import { AccountServiceConfig, ACCOUNT_CONFIG } from './account.config';
import { AccountService } from './account.service';

/**
 * Factory method for configuring the social authentication.
 */
export function AuthServiceConfigFactory(config: AccountServiceConfig): AuthServiceConfig {
  const data = [];

  if (config.facebookId) {
    data.push({
      id: FacebookLoginProvider.PROVIDER_ID,
      provider: new FacebookLoginProvider(config.facebookId),
    });
  }

  if (config.googleId) {
    data.push({
      id: GoogleLoginProvider.PROVIDER_ID,
      provider: new GoogleLoginProvider(config.googleId)
    });
  }

  return new AuthServiceConfig(data);
}

@NgModule({
  imports: [
    SocialLoginModule,
  ],
  providers: [
    AuthService,
  ],
})
export class AccountModule {

  static forRoot(config: AccountServiceConfig): ModuleWithProviders<AccountModule> {
    return {
      ngModule: AccountModule,
      providers: [
        SessionService,
        UserService,
        ProfileService,
        RecoveryService,
        AccountService,
        {
          provide: ACCOUNT_CONFIG,
          useValue: config,
        },
        {
          provide: USER_CONFIG,
          useValue: config.userConfig,
        },
        {
          provide: AuthServiceConfig,
          useFactory: AuthServiceConfigFactory,
          deps: [ACCOUNT_CONFIG],
        },
      ],
    };
  }

  static forChild(config: AccountServiceConfig): ModuleWithProviders<AccountModule> {
    return AccountModule.forRoot(config);
  }

}
